import format from '@/utils/format'
import  toLowerLine  from '@/utils/toLowerLine'

/**
 * 表格数据过滤公共方法
 * @param data 表格数据
 * @param field 字段
 * @returns {string}
 */
export function filterTableData (data,field) {
    let result = ""
    switch (field) {
        case "createDate":
            result = format(data[field],"YYYY-MM-DD HH:mm:ss")
            break
        case "confirmDate":
            result = format(data[field],"YYYY-MM-DD HH:mm:ss")
            break
        case "startDate":
            result = format(data[field],"YYYY-MM-DD HH:mm:ss")
            break
        case "endDate":
            result = format(data[field],"YYYY-MM-DD HH:mm:ss")
            break
        case "returnDate":
            result = format(data[field],"YYYY-MM-DD HH:mm:ss")
            break
        case "outDate":
            result = format(data[field],"YYYY-MM-DD HH:mm:ss")
            break
        case "expectDate":
            result = format(data[field],"YYYY-MM-DD HH:mm:ss")
            break
        case "reportDate":
            result = format(data[field],"YYYY-MM-DD HH:mm:ss")
            break
        case "effectiveDate":
            result = format(data[field],"YYYY-MM-DD HH:mm:ss")
            break
        case "orderUnderDate":
            result = format(data[field],"YYYY-MM-DD HH:mm:ss")
            break
        case "state":
            if (data[field] == 1){
                result = "有效"
            }else{
                result = "无效"
            }
            break;
        case "arc":
            if (data[field] == 1){
                result = "已发送"
            }else{
                result = "待发送"
            }
            break;
        default:
            result = data[field]
    }
    return result
}

/**
 * 分页
 * @param event 原始分页参数
 * @param queryParams 查询参数
 * @param fun 查询方法
 * @returns {*}
 */
export function onPages(event,queryParams,fun){
    if (Object.keys(queryParams).includes("bioTechLeaguePagingQuery")){
        queryParams.bioTechLeaguePagingQuery.page = event.page + 1
        queryParams.bioTechLeaguePagingQuery.rows = event.rows
    }else {
        queryParams.page = event.page + 1;
        queryParams.rows = event.rows;
    }
    fun(queryParams).then(res => {
        queryParams.totalRecords = res.data.data.total
        queryParams.tableData = res.data.data.result
    })
    return queryParams
}

/**
 * 分页
 * @param event 原始分页参数
 * @param queryParams 查询参数
 * @param fun 查询方法
 * @param url 请求地址
 * @returns {*}
 */

export function onPagesForBioDdataTable(event,queryParams,fun,url){
    if (Object.keys(queryParams).includes("bioTechLeaguePagingQuery")){
        queryParams.bioTechLeaguePagingQuery.page = event.page + 1
        queryParams.bioTechLeaguePagingQuery.rows = event.rows
    }else {
        queryParams.page = event.page + 1;
        queryParams.rows = event.rows;
    }
    fun(queryParams,url).then(res => {
        queryParams.totalRecords = res.data.data.total
        queryParams.tableData = res.data.data.result
    })
    return queryParams
}

/**
 * 排序
 * @param event 原始排序参数
 * @param queryParams 查询参数
 * @param fun 查询方法
 * @returns {*}
 */

export function onSort(event,queryParams,fun){
    queryParams.sort["sortFiled"] = toLowerLine( event["sortField"])
    queryParams.sort["sortOrder"] = event["sortOrder"]
    fun(queryParams).then(res => {
        queryParams.totalRecords = res.data.data.total
        queryParams.tableData = res.data.data.result
    })
    return queryParams
}

/**
 * 表格筛选
 * @param event 原始筛选参数
 * @param queryParams 查询参数
 * @param fun 查询方法
 * @returns {*}
 */
export function onFilter(event,queryParams,fun){
    queryParams.query = []
    for (let key in event.filters) {
        var filtersArr = []
        var matchMode = ""
        for (var s in event.filters[key].constraints) {
            var filters = {}
            let content = event.filters[key].constraints[s]["value"]
            var matchModeTemp = event.filters[key].constraints[s]["matchMode"]
            if (content != null) {
                switch (matchModeTemp) {
                    case "startsWith":
                        matchMode = "likeRight"
                        break
                    case "contains":
                        matchMode = "like"
                        break
                    case "notContains":
                        matchMode = "notLike"
                        break
                    case "endsWith":
                        matchMode = "likLeft"
                        break
                    case "equals":
                        matchMode = "eq"
                        break
                    case "notEquals":
                        matchMode = "ne"
                        break
                }
                filters["operator"] = event.filters[key].operator
                filters["value"] = content
                filters["fieldName"] = key
                filters["matchMode"] = matchMode
            }
            filtersArr.push(filters)
        }
        if (filtersArr.length > 0 && JSON.stringify(filters) !== "{}") {
            queryParams.query.push(filtersArr)
        }
    }
    console.log(queryParams.query)
    fun(queryParams).then(res => {
        queryParams.totalRecords = res.data.data.total
        queryParams.tableData = res.data.data.result
    })
    return queryParams
}

/**
 * 表格编辑
 * @param event 原始编辑参数
 * @returns {*}
 */
export function onCellEditComplete(event) {
    let {data, newValue, field} = event;
    if (newValue !== null) {
        switch (field) {
            case "createDate":
                data[field] = format(newValue,"YYYY-MM-DD HH:mm:ss")
                break
            case "confirmDate":
                data[field] = format(newValue,"YYYY-MM-DD HH:mm:ss")
                break
            case "expireDate":
                data[field] = format(newValue,"YYYY-MM-DD HH:mm:ss")
                break
            case "returnDate":
                data[field] = format(newValue,"YYYY-MM-DD HH:mm:ss")
                break
            case "expectDate":
                data[field] = format(newValue,"YYYY-MM-DD HH:mm:ss")
                break
            case "reportDate":
                data[field] = format(newValue,"YYYY-MM-DD HH:mm:ss")
                break
            case "effectiveDate":
                data[field] = format(newValue,"YYYY-MM-DD HH:mm:ss")
                break
            default:
                data[field] = newValue;
        }
    }else{
        event.preventDefault();
        // break;
    }
}

export function onCellEditCompleteForBioTable(event,column) {
    let {data, newValue, field} = event;
    if (newValue) {
        column.map(item => {
            if(item.type && item.type === "calendar"){
                data[field] = format(newValue,"YYYY-MM-DD HH:mm:ss")
                console.log(data[field])
            }else{
                data[field] = newValue;
            }
        })
    }else{
        event.preventDefault();
    }
}
